import React from 'react'
import api from 'src/services/api'
import { ILicenseProducts, ILicenseSubscription } from 'src/types/types'

const useSubscriptions = () => {
    const [subscriptions, setSubscriptions] = React.useState<ILicenseSubscription[]>([])
    const [loading, setLoading] = React.useState(true)
    const [error, setError] = React.useState(null)

    const fetchSubscriptions = async () => {
        try {
            const result = await api.get('/licenses/with-product?isMonthly=1');
            setSubscriptions(result.data.licenseList);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }

    return { subscriptions, loading, error, fetchSubscriptions }
}

export default useSubscriptions